import {createAction, props} from "@ngrx/store";
import {AssetTypeModel, FilterKeyValuePairInterface, PaginationInfoInterface} from "../../interfaces";

export const addAssetType = createAction("[AssetType] Add AssetType", props<{assetType: AssetTypeModel}>());

export const addAssetTypes = createAction("[AssetType] Add AssetTypes", props<{assetTypes: Array<AssetTypeModel>}>());

export const updateAssetType = createAction("[AssetType] Update AssetType", props<{assetType: AssetTypeModel}>());

export const setAssetTypes = createAction("[AssetType] Set AssetTypes", props<{assetTypes: Array<AssetTypeModel>}>());

export const setPaginatedAssetTypes = createAction(
  "[AssetType] Set Paginated AssetTypes",
  props<{assetTypes: Array<AssetTypeModel>}>()
);

export const setAssetTypesPaginationInfo = createAction(
  "[AssetType] Set PaginationInfo",
  props<{paginationInfo: PaginationInfoInterface}>()
);

export const gotoAssetTypesPage = createAction("[AssetType] Goto Page", props<{page: number}>());

export const applyAssetTypesFilters = createAction(
  "[AssetType} Apply Filter",
  props<{filters: Array<FilterKeyValuePairInterface>}>()
);

export const setAssetTypeQuery = createAction("[AssetType] Set AssetType Query", props<{query: string}>());

export const setAssetTypeQueryItems = createAction(
  "[AssetType] Set AssetType Query Items",
  props<{items: Array<AssetTypeModel>}>()
);

export const resetAssetTypesFilters = createAction("[AssetType] Reset Filters");
